import { request, resetCustomOnResponseError, setCustomOnResponseError } from './axios'
import { Distributor } from '../component/common'
import type { TUploaded, THistoryData } from '../type'
import { AxiosResponse } from 'axios'
import { createDownloadLink } from '../utility/download-link'
import { customErrorResponse } from '../utility/custom-error-response'

export const Upload = {
  create: async (
    ce_340b_id: string,
    file_type: string,
    distributor: string,
    dea_id: string,
    pharmacyBrand: string,
    files: File[],
    updateProgress: (percent: number) => void,
  ): Promise<AxiosResponse<TUploaded>> => {
    setCustomOnResponseError(customErrorResponse)
    let url = `/aux/upload/?file_type=${file_type}`
    if (file_type === Distributor.INVOICES) {
      url += `&distributor=${distributor}`
    }
    if (file_type === Distributor.RX_TPA) {
      url += `&dea_id=${dea_id}`
      url += `&pharmacy_brand=${pharmacyBrand}`
    }
    if (file_type !== Distributor.INVOICES) {
      url += `&ce_340b_id=${ce_340b_id}`
    }

    const formData = new FormData()
    files.forEach((file, i) => formData.append(`file${i}`, file))

    return request({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url,
      method: 'post',
      data: formData,
      onUploadProgress: (progressEvent) => {
        if (progressEvent.total) {
          updateProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
        }
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },

  template: async (file_type: string): Promise<void> => {
    const { data } = await request({
      responseType: 'arraybuffer',
      url: `/aux/download/template/?file_type=${file_type}`,
      method: 'post',
    })
    createDownloadLink(data, `aux_template_${file_type}.xlsx`)
  },

  get: async (page = 1): Promise<THistoryData> => {
    const {
      data: { history, max_page_size, page_number, total_count, total_pages },
    } = await request({
      url: `/aux/history/?page_number=${page}`,
    })

    return { history, max_page_size, page_number, total_count, total_pages }
  },

  excel: async (): Promise<void> => {
    const { data } = await request({
      responseType: 'arraybuffer',
      url: '/aux/history/export_to_excel/',
      method: 'post',
    })
    createDownloadLink(data, 'aux_uploads_history.xlsx')
  },
}
